import { render, staticRenderFns } from "./DocumentPage.vue?vue&type=template&id=11710fd3&"
import script from "./DocumentPage.vue?vue&type=script&lang=js&"
export * from "./DocumentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports